module.exports = __webpack_public_path__ + "static/scale-model-of-elvis-statue-in-memphis-tennessee-aca06406d50ef93626eaed3c23ebcbb1.png";